import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store"; // Should be imported at lastline.

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/login",
    name: "Login",
    meta: { noAuth: true },
    component: () => import("@/components/Login/SSOLogin"),
  },
  {
    path: "/m/login",
    name: "MobileLogin",
    meta: { noAuth: true },
    component: () => import("@/components/Login/MobileLogin"),
  },
  {
    path: "/",
    name: "Map",
    component: () => import("@/views/Map"),
  },
  // DEV
  {
    path: "/dev",
    name: "MapDev",
    component: () => import("@/views/Map"),
  },
  {
    path: "/mypage",
    name: "Mypage",
    component: () => import("@/components/Mypage/mypage"),
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("@/components/Admin/Admin"),
  },
  {
    path: "/statistics",
    name: "Statistics",
    component: () => import("@/components/Statistics/Statistics"),
  },
  {
    path: "/reference",
    name: "Reference",
    component: () => import("@/components/Reference/Reference"),
  },
  {
    path: "/adminLogin",
    name: "AdminLogin",
    meta: { noAuth: true },
    component: () => import("@/components/Login/Login"),
  },
  {
    path: "/callback",
    name: "CallBack",
    meta: { noAuth: true },
    component: () => import("@/views/CallbackView"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // 권한이 필요한 페이지일경우 로그인 체크.
  // isLoggenIn false, user&group 정보 없을때,
  let user = store.getters.getUser;
  if (
    !to.meta.noAuth &&
    (!store.state.auth.isLoggedIn ||
      !user ||
      !user.groups ||
      user.groups.length == 0)
  ) {
    return next({
      path: "/login",
      query: { redirect: to.fullPath },
    });
  }
  next();
});

export default router;
